const API_ENDPOINT = 'https://api.rakutenmarketing.com/';
const API_CONSUMER_KEY = "Vmp8RYJkoCr_87sVLmg79C6qwYka";
const API_CONSUMER_SECRET = "JSVfFNoRcfa2EvplMgauWB2yqfoa";
const TOKEN_REQUEST = "Basic Vm1wOFJZSmtvQ3JfODdzVkxtZzc5QzZxd1lrYTpKU1ZmRk5vUmNmYTJFdnBsTWdhdVdCMnlxZm9h";
const CLIENT_ID = '3652579';
const USERNAME = 'Adm_DB';
const PASSWORD = '128961C2G';
const NETWORK = '8';
const functions = require('../utils/functions')
const qs = require('qs');
var convert = require('xml-js');
import axios from 'axios'

function hasAccessToken()
{
  if(localStorage.getItem('rakuten-refresh-token') && localStorage.getItem('rakuten-token')){
    return true;
  }
  return false;
}

function getHeaders()
{
  var token = localStorage.getItem('rakuten-token');
  return {
    'Authorization': token,
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
}

function getAccessToken(callback){
  axios.post(API_ENDPOINT + 'token', 
  qs.stringify({
    grant_type: 'password',
    username: USERNAME,
    password: PASSWORD,
    scope: CLIENT_ID
  }), {headers: {
    'Authorization': TOKEN_REQUEST,
    'Content-Type': 'application/x-www-form-urlencoded'
  }}).then((res) => {
    localStorage.setItem('rakuten-token', 'Bearer ' + res.data.access_token);
    localStorage.setItem('rakuten-refresh-token', res.data.refresh_token);
    callback()
  }, (err) => {
    //Verificar se o token expirou, então chamar o refresh
    updateAccessToken(callback);
  });
}

function updateAccessToken(callback){
  var refreshToken = localStorage.getItem('rakuten-refresh-token');
  return axios.post(API_ENDPOINT + 'token', {
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    scope: 'Production',
  }, {headers: {
    'Authorization': TOKEN_REQUEST
  }}).then((res) => {
    localStorage.setItem('rakuten-token', JSON.stringify(res.token_type + ' ' + res.access_token));
    localStorage.setItem('rakuten-refresh-token', res.refresh_token);
    return callback()
  });
}

function getCoupons(callback){
  return getAccessToken(() => {
    return axios.get(API_ENDPOINT + 'coupon/1.0?resultsperpage=200', {headers: getHeaders()}).then((res) => {
      var json = convert.xml2js(res.data, {compact: true, spaces: 4});
      callback(json.couponfeed.link)
    });
  })
}

function getProducts(callback){
  getAccessToken(() => {
    axios.get(API_ENDPOINT + 'productsearch/1.0?keyword=capa&language=pt_BR&resultsperpage=200', {headers: getHeaders()}).then((res) => {
      var json = convert.xml2js(res.data, {compact: true, spaces: 4});
      callback(json)
    });
  })
}

function getStores(callback){
  return getAccessToken(() => {
    return axios.get(API_ENDPOINT + 'advertisersearch/1.0' ,{headers: getHeaders()}).then((res) => {
      var json = convert.xml2js(res.data, {compact: true, spaces: 4});
        callback(json.result.midlist.merchant)
    });;
  })
}

function getProductCategories(){
  return axios.get(API_ENDPOINT + 'category/_bestsellers/?sourceId=' + API_SOURCEID);
}

function convertCoupon(coupon){
  var slug = functions.stringToSlug(coupon.advertisername._text + '-' + coupon.advertiserid._text);
  return {
    'CouponId': coupon.advertiserid._text,
    'StoreId': coupon.advertiserid._text,
    'CategoryId': coupon.categories.category._attributes.id,
    'store': coupon.advertisername._text,
    'category': coupon.categories.category._text,
    'slug': slug,
    'originalId': coupon.advertiserid._text,
    'couponType': 'rakuten',
    'description': coupon.offerdescription._text,
    'trackingLink': coupon.clickurl._text,
    'image': coupon.impressionpixel._text,
    'value': null,
    'code': null,
    'dateBegin': coupon.offerstartdate._text,
    'dateEnd': coupon.offerenddate._text
  }
}

export default {
  getCoupons,
  convertCoupon,
  getProducts,
  getStores,
  getProductCategories,
  getAccessToken,
  getHeaders,
  API_ENDPOINT
}


// WEBPACK FOOTER //
// ./src/drivers/rakuten.js